

<!-- <dashboardnav> -->

<!-- 
<main class="main_staff-entry">
  <form [formGroup]="staffForm">
    <div class="sign_in">
        <h2 class="title">New Staff</h2>
        <div class="contain">
            
          <div class="the_input">
            <label for="">Last Name</label>
            <input type="text" class="default_input" placeholder="Enter Last Name" formControlName="LastName"/>
          </div>
          <div class="the_input">
            <label for="">First Name</label>
            <input type="text" class="default_input" placeholder="Enter First Name" formControlName="FirstName"/>
          </div>
          <div class="the_input">
            <label for="">Middle Name</label>
            <input type="text" class="default_input" placeholder="Enter Middle Name" formControlName="MiddleName"/>
          </div>
          <div class="the_input">
            <label for="">Phone Number</label>
            <input type="number" class="default_input" placeholder="Enter Mobile Number" formControlName="PhoneNo"/>
          </div>
          <div class="the_input">
            <label for="">Email</label>
            <input type="email" class="default_input"  placeholder="Enter email" formControlName="EmailAddress"/>
          </div>
        </div>

        <div class="submit">
          <button class="default_primary-button" (click)="onSubmit()">Sign in</button>
        </div>
      </div>





  
   
  </form>

</main>

<div class="box green_box"></div>
<div class="box pink_box"></div> -->




<!-- </dashboardnav> -->




<!-- <dashboardnav> -->




    <main class="reference_form-main">
        <div class="main_container">
          <form [formGroup]="staffForm">
          <div class="">
            <h3 class="form_name">Contractor Form</h3>
      
            <div class="input">
              <label for="">Contractor Name<span class="text-danger">*</span></label>
              <label for="">Contractor<span class="text-danger">*</span></label>
              <mat-select placeholder="Contractor" name="item" class="default_input reference-form"  formControlName="ParentId">
                  <mat-option *ngFor="let contractor of contractors" [value]="contractor.id">
                      {{contractor.StaffName}}
                  </mat-option>
              </mat-select>
            </div>
            <div class="input">
                <label for="">LastName<span class="text-danger">*</span></label>
                <input type="text" class="default_input reference-form" formControlName="LastName" />
              </div>
    
                <div class="input">
                <label for="">FirstName<span class="text-danger">*</span></label>
                <input type="text" class="default_input reference-form" formControlName="FirstName" />
              </div>
    
              <div class="input">
                <label for="">Middle Name<span class="text-danger">*</span></label>
                <input type="text" class="default_input reference-form" formControlName="MiddleName" />
              </div>
    
    
              <div class="input">
                <label for="">Phone Number<span class="text-danger">*</span></label>
                <input type="text" class="default_input reference-form" formControlName="PhoneNo" />
              </div>
           
              <div class="input" *ngIf="!editstatus" >
                <label for="">Email<span class="text-danger">*</span></label>
                <input type="email" class="default_input reference-form" formControlName="EmailAddress" />
             
              </div>
      
            <div class="btn_holder">
                <button class="default_primary-button" *ngIf="!editstatus"  (click)="onSubmit()">Submit</button>
                <button class="default_primary-button" *ngIf="editstatus"  (click)="updateStaff(staffForm.value)">Submit</button>
                 <button class="default_primary-button btn-default" (click)="resetForm()">Reset</button>
            </div>
      
          </div>
        </form>
          <div class="display_table">
            <div class="search_container">
              <input type="text" class="default_input search"
              placeholder="Search for Contractor name"
              #name
              (keyup)="searchContractorsStaff(name.value)"
              />
              <em  class="ti-search" (click)="searchContractorsStaff(name.value)"></em>
      
            </div>
      
            <div class="head" >
              <span class="item">S/N</span>
             
              <span class="item">Staff</span>
              <span class="item">Phone Number</span>
              <span class="item">Email</span>
             
              <!-- <span class="item">Action</span> -->
      
            </div>
      
          <div class="scroll">
      
          </div>
          <div class="body_content" >
            <div class="the_body"
            *ngFor="let contractorstaff of searchcontractorstaff; index as i"
            (click)="onEdit(contractorstaff)" style="cursor: pointer;"
            matTooltip="Click to edit"
              aria-label="Button that displays a tooltip when focused or hovered over"
            >
              <span class="content">{{i + 1}}</span>
              
              <span class="content">{{contractorstaff.StaffName}}</span>
    
              <span class="content">{{contractorstaff.PhoneNo}}</span>
               <span class="content">{{contractorstaff.Email}}</span>
             
              <!-- <span class="content" (click)="$event.stopImmediatePropagation()">
                <button
                class="delete_icon trash"
      
                (click)="deleteSeismicContractor(i, seismiccontractor.value)">
                <em  class="ti-trash"> </em></button>
              </span> -->
      
            </div>
            </div>
          </div>
        </div>
      </main>
      
      <div class="box green_box"></div>
      <div class="box pink_box"></div>
    
    <!-- </dashboardnav> -->